import Moment from "moment";
export function dateDiff(from, format = 'days', to = null) {
    to = to ? Moment(to) : Moment();
    return Moment(to).diff(from, format);
}
